/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type DeviceTypeResponseDto = {
  id: number;
  name: string;
  displayName: string;
  description?: string;
  status: DeviceTypeResponseDto.status;
  createdAt: string;
  updatedAt: string;
  version: number;
  measurements: any;
  coapDefinition: any;
};
export namespace DeviceTypeResponseDto {
  export enum status {
    ACTIVE = 'ACTIVE',
    DELETION_IN_PROGRESS = 'DELETION_IN_PROGRESS',
  }
}

